import React from 'react';
import classnames from 'classnames';

// Components
// import WpTextTruncate from '../text-truncate/WpTextTruncate';

import './WpPageTitle.scss';

export interface Props {
  title: string;
  subTitle?: string;
  buttonsContainer?: React.ReactNode;
  customContentComponent?: React.ReactNode;
  prefix?: React.ReactNode;
  postfix?: React.ReactNode;
  breadcrumbs?: React.ReactNode;
  buttonsOnMobile?: 'hide' | 'stack' | 'inline';
}

const WpPageTitle: React.FC<Props> = ({
  title,
  subTitle = '',
  buttonsContainer,
  prefix,
  postfix,
  breadcrumbs,
  buttonsOnMobile = 'stack',
  customContentComponent,
}: Props) => {
  const baseClassName = 'WpPageTitle';

  const classes = classnames(baseClassName, buttonsOnMobile === 'stack' && `${baseClassName}--${buttonsOnMobile}`);

  const btnClasses = classnames(`${baseClassName}__actions`, `${baseClassName}__actions--${buttonsOnMobile}`);

  return (
    <div className={classes}>
      <div className={`${baseClassName}__wrapper`}>
        {breadcrumbs && <div className={`${baseClassName}__wrapper__breadcrumbs`}>{breadcrumbs}</div>}
        <div className={`${baseClassName}__wrapper__content`}>
          {customContentComponent ? (
            <>{customContentComponent}</>
          ) : (
            <>
              {prefix && <div className={`${baseClassName}__wrapper__content__prefix`}>{prefix}</div>}
              <div className={`${baseClassName}__wrapper__content__title-area`}>
                <h3 className={`${baseClassName}__wrapper__content__title-area__title`}>{title}</h3>
                {subTitle && (
                  <p className={`${baseClassName}__wrapper__content__title-area__sub-title`}>
                    {subTitle}
                    {/* <WpTextTruncate text={subTitle} numberOfLines={1} showTooltip /> */}
                  </p>
                )}
              </div>
              {postfix && <div className={`${baseClassName}__wrapper__content__postfix`}>{postfix}</div>}
            </>
          )}
        </div>
      </div>
      {buttonsContainer && <div className={btnClasses}>{buttonsContainer}</div>}
    </div>
  );
};

export default WpPageTitle;
